import { isArray, sortBy, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { Modal, ModalService } from '@sm360/widget-commons-general';
import { ModelYear } from '@sm360/widget-commons-vehicle';

import FeatureIcon from 'build-and-quote/components/ModelTrims/ModelTrimFeatures/FeatureIcon.jsx';

import 'build-and-quote/components/ModelTrims/modelTrimFeatures.scss';

const MODAL = 'widget/FeaturesSection';

class ModelTrimFeatures extends React.Component {
    constructor(props) {
        super(props);

        this.modal = ModalService.get(MODAL);

        this.state = {
            selectedModelTrim: this.props.selectedModelTrim,
        };

        this.getFeatureIcons = this.getFeatureIcons.bind(this);
        this.renderFeatureIcons = this.renderFeatureIcons.bind(this);
        this.renderFeatures = this.renderFeatures.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (!newProps || !newProps.selectedModelTrim || this.props === newProps) {
            return;
        }

        this.setState({
            selectedModelTrim: newProps.selectedModelTrim,
        });
    }

    getFeatureIcons() {
        const modelTrim = this.state.selectedModelTrim;
        if (!modelTrim) {
            return null;
        }

        const featureIcons = modelTrim.get('comparisonAddFeatureIcons').toArray() || [];
        return sortBy(featureIcons, (rankIcon) => rankIcon.get('rank'));
    }

    renderFeatureIcons(featureIcons) {
        if (!featureIcons) {
            return <li />;
        }

        return featureIcons.map((featureIcon) => (
            <FeatureIcon
                key={`${featureIcon.get('code')}|${featureIcon.getIn(['iconObject', 'code'])}`}
                code={featureIcon.get('code')}
                description={featureIcon.getIn(['iconObject', 'typeDescription'])}
            />
        ));
    }

    renderFeatures(modelTrimFeatures) {
        if (isEmpty(modelTrimFeatures?.features)) {
            return <div>{LocaleService.t('summarySection.no_features_available')}</div>;
        }
        return (
            <ul>
                {Object.values(modelTrimFeatures.features).map((feature) => (
                    <li className="features-bloc">
                        <div className="features-bloc--content">{feature.description}</div>
                    </li>
                ))}
            </ul>
        );
    }

    render() {
        const isDisplaying = !!this.state.selectedModelTrim;

        const featureTitle = LocaleService.t('modelTrimSection.featurePopupTitle', {
            modelTrim: isDisplaying ? this.state.selectedModelTrim.getModelTrimFullDescription() : '',
        });

        const modelTrim = isDisplaying ? this.state.selectedModelTrim.description : '';

        const modalCustomStyles = {
            overlay: {
                zIndex: 2147483643,
                backgroundColor: 'rgba(0, 0, 0, 0.75)',
            },
        };

        const featureIconList = this.getFeatureIcons();
        const featureIconShortList = isArray(featureIconList) && featureIconList.slice(0, 11);

        return (
            <section className="style-specs">
                <div className="style-specs__get-more-title sr-subtitle-2">
                    {LocaleService.t('modelTrimSection.featurePopupTitle', { modelTrim })}
                </div>
                <ul className="style-specs__lists car-equipments_summary">
                    {this.renderFeatureIcons(featureIconShortList)}
                    <li>
                        <button className="style-specs__lists__see-more sr-link" onClick={this.modal.open}>
                            {LocaleService.t('summarySection.seeAllFeatures')}
                        </button>
                    </li>
                </ul>

                <Modal
                    name={MODAL}
                    contentLabel="features section dialog"
                    className="buildAndQuote__feature_dialog"
                    style={modalCustomStyles}
                >
                    <div className="style-specs__modal-close-bloc">
                        <button className="modal-close icon-showroom" onClick={this.modal.close} />
                    </div>
                    <div className="style-specs__modal car-equipments_summary is-scrollable">
                        <div className="style-specs__modal-title sr-subtitle-2">{featureTitle}</div>
                        {this.renderFeatures(this.state.selectedModelTrim)}
                    </div>
                </Modal>
            </section>
        );
    }
}

ModelTrimFeatures.propTypes = {
    selectedModelTrim: PropTypes.instanceOf(ModelYear.ModelTrimModel).isRequired,
};

ModelTrimFeatures.displayName = 'ModelTrimFeatures';

export default ModelTrimFeatures;
